/* Draft All Fish: source collection filters + server-verified All Fish membership. */
(function () {
  'use strict';
  const TYPE = 'fish_type', STOCK = 'filter.v.availability';
  const MIN = 'filter.v.price.gte', MAX = 'filter.v.price.lte';
  const cache = new Map();
  function prepare(current, resetPage = true) {
    const url = new URL(current);
    url.searchParams.delete('section_id');
    if (resetPage) url.searchParams.delete('page');
    url.hash = ''; return url;
  }
  function inCollection(current, base) {
    const url = new URL(current), root = new URL(base, url.origin);
    return url.origin === root.origin && url.pathname.replace(/\/$/, '') === root.pathname.replace(/\/$/, '');
  }
  function selectType(current, type) {
    const url = prepare(current);
    if (type && !/^[a-z0-9][a-z0-9-]*$/.test(type)) throw new TypeError('Invalid fish group');
    if (type && url.searchParams.get(TYPE) !== type) url.searchParams.set(TYPE, type);
    else url.searchParams.delete(TYPE);
    return url;
  }
  function toggleStock(current) {
    const url = prepare(current), active = url.searchParams.getAll(STOCK).includes('1');
    url.searchParams.delete(STOCK);
    if (!active) url.searchParams.set(STOCK, '1');
    return url;
  }
  function priceValue(value) {
    const input = String(value == null ? '' : value).trim();
    if (!input) return '';
    if (!/^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(input) || !Number.isFinite(Number(input))) throw new RangeError('Enter a valid price.');
    return String(Number(input));
  }
  function setPrice(current, minimum, maximum) {
    const low = priceValue(minimum), high = priceValue(maximum), url = prepare(current);
    if (low !== '' && high !== '' && Number(low) > Number(high)) throw new RangeError('The maximum price must be at least the minimum price.');
    [[MIN, low], [MAX, high]].forEach(([key, value]) => value === '' ? url.searchParams.delete(key) : url.searchParams.set(key, value));
    return url;
  }
  function removeFilter(current, name) {
    const url = prepare(current);
    if (name === 'price') { url.searchParams.delete(MIN); url.searchParams.delete(MAX); }
    else url.searchParams.delete(name);
    return url;
  }
  function clearFilters(current) {
    const url = prepare(current); url.searchParams.delete(TYPE);
    Array.from(url.searchParams.keys()).forEach(key => { if (key.startsWith('filter.')) url.searchParams.delete(key); });
    return url;
  }
  function pageUrl(current, page) {
    const url = prepare(current);
    if (page > 1) url.searchParams.set('page', String(page));
    return url;
  }
  function sourceUrl(current, source, previewThemeId) {
    const selected = new URL(current), url = new URL(source, selected.origin);
    if (url.origin !== selected.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[a-z0-9-]+\/?$/.test(url.pathname)) throw new TypeError('Invalid fish source');
    url.search = ''; url.searchParams.set('view', 'mas-fish-filter');
    for (const [key, value] of selected.searchParams) {
      if (key.startsWith('filter.') || ['sort_by', 'preview_theme_id'].includes(key)) url.searchParams.append(key, value);
    }
    if (previewThemeId && /^\d+$/.test(String(previewThemeId))) url.searchParams.set('preview_theme_id', String(previewThemeId));
    return url;
  }
  function pagination(total, size, requested) {
    const pages = Math.max(1, Math.ceil(total / size));
    const page = Math.min(pages, Math.max(1, parseInt(requested, 10) || 1));
    return { page, pages, start: (page - 1) * size, end: Math.min(total, page * size) };
  }
  function queryKey(current) {
    const url = prepare(current); url.searchParams.sort(); return url.toString();
  }
  function availabilityBuckets(current) {
    const selected = new URL(current).searchParams.getAll(STOCK);
    return selected.includes('0') && !selected.includes('1') ? ['0'] : selected.includes('1') && !selected.includes('0') ? ['1'] : ['1', '0'];
  }
  function progressivePagination(result, size, requested) {
    const total = result.complete ? result.cards.length : result.total;
    const known = Number.isFinite(total), wanted = Math.max(1, parseInt(requested, 10) || 1);
    const pages = known ? Math.max(1, Math.ceil(total / size)) : null;
    const page = known ? Math.min(pages, wanted) : wanted;
    return { page, pages, start: (page - 1) * size, end: Math.min(result.cards.length, page * size),
      hasNext: known ? page < pages : result.cards.length > page * size || !result.complete, total: known ? total : null };
  }
  function checkAbort(signal) {
    if (signal?.aborted) { const error = new Error('Fish request cancelled'); error.name = 'AbortError'; throw error; }
  }
  function matchesSubset(value, subset) {
    if (!subset) return true;
    return String(value || '').split('|').some(token => token.trim() === subset);
  }
  function cardsInSubset(records, subset) {
    const available = [], soldOut = [];
    records.forEach(record => {
      if (matchesSubset(record.subset, subset)) (record.available === false ? soldOut : available).push(record.html);
    });
    // Partition the complete source result before taking a display page, retaining Shopify's sort in each bucket.
    return available.concat(soldOut);
  }
  function cardRecord(element) {
    const wrapped = element.matches?.('template[data-fish-record]');
    const availability = element.getAttribute('data-fish-available');
    return {
      html: wrapped ? element.innerHTML : element.outerHTML,
      subset: element.getAttribute('data-fish-subset'),
      available: availability === null ? !element.classList?.contains('hdt-pr-sold_out') : availability !== 'false'
    };
  }
  function railGeometry(width, gap, minimum, maximum, total) {
    const count = Math.max(1, Math.min(total, maximum, Math.floor((width + gap) / (minimum + gap))));
    const itemWidth = (width - gap * (count - 1)) / count;
    return { count, itemWidth, step: itemWidth + gap, lastStart: Math.max(0, total - count) };
  }
  function railVisibleStart(index, start, count, total) {
    const next = index < start ? index : index >= start + count ? index - count + 1 : start;
    return Math.max(0, Math.min(total - count, next));
  }
  const helpers = { prepare, inCollection, selectType, toggleStock, setPrice, removeFilter, clearFilters, pageUrl, sourceUrl, pagination, progressivePagination, availabilityBuckets, queryKey, matchesSubset, cardsInSubset, cardRecord, railGeometry, railVisibleStart };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  if (typeof window === 'undefined' || !window.customElements || customElements.get('mas-fish-filter')) return;

  class FishFilter extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.base = this.dataset.baseUrl; this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById('shopify-section-' + this.sectionId);
      if (!this.base || !this.section || !inCollection(location.href, this.base)) return;
      this.listeners = new AbortController(); this.groups = new Map([['', { source: this.base, subset: '', label: 'All Fish' }]]);
      this.querySelectorAll('[data-fish-type][data-fish-source]').forEach(link => {
        this.groups.set(link.dataset.fishType, {
          source: link.dataset.fishSource,
          subset: link.dataset.fishSubset || '',
          label: link.dataset.fishLabel || link.textContent.trim().replace(/\s+/g, ' ')
        });
      });
      this.size = Math.max(1, Number(this.dataset.pageSize) || 30);
      this.gridSelector = this.dataset.gridSelector || '#products-' + this.sectionId;
      this.paginationHost = this.querySelector('[data-fish-pagination]') || this.section.querySelector('[data-fish-pagination]');
      this.status = this.querySelector('[data-fish-status]'); this.count = this.querySelector('[data-fish-count]');
      const options = { signal: this.listeners.signal };
      this.track = this.querySelector('[data-fish-track]');
      if (this.track) {
        const updateScroll = () => this.updateScrollButtons();
        const resizeTrack = () => this.sizeTrack();
        this.track.addEventListener('scroll', updateScroll, { ...options, passive: true });
        this.track.addEventListener('load', updateScroll, { ...options, capture: true });
        window.addEventListener('resize', resizeTrack, { ...options, passive: true });
        if (typeof ResizeObserver !== 'undefined') {
          this.trackResize = new ResizeObserver(resizeTrack); this.trackResize.observe(this.track);
        }
        this.sizeTrack();
      }
      this.section.addEventListener('click', this.onClick.bind(this), options);
      this.addEventListener('submit', this.onSubmit.bind(this), options);
      this.addEventListener('input', event => { if (event.target.matches('[data-fish-price-form] input')) event.target.setCustomValidity(''); }, options);
      this.addEventListener('keydown', event => {
        const form = this.querySelector('[data-fish-price-form]');
        if (event.key === 'Escape' && form && !form.hidden) { event.preventDefault(); this.showPrice(false, true); }
        if (event.key === ' ' && event.target.matches('a[data-fish-type][role="button"]')) { event.preventDefault(); event.target.click(); }
      }, options);
      document.addEventListener('change', this.beforeForm.bind(this), { ...options, capture: true });
      document.addEventListener('submit', this.beforeForm.bind(this), { ...options, capture: true });
      document.addEventListener('facet:render', this.beforeFacet.bind(this), { ...options, capture: true });
      if (!history.state?.FacetUrl) history.replaceState({ ...history.state, FacetUrl: location.href, section_id: this.sectionId }, '', location.href);
      this.busy(false);
      this.sync(new URL(location.href));
      if (!new URL(location.href).searchParams.has(TYPE)) {
        this.displayedQuery = queryKey(this.withPreview(location.href));
        this.displayedCount = this.count?.textContent || '';
      }
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.loadGroup(new URL(location.href), { push: false, initial: true });
      });
    }
    disconnectedCallback() {
      this.listeners?.abort(); this.listeners = null; this.request?.abort(); clearTimeout(this.groupTimer);
      this.cancelPrefetch();
      this.trackResize?.disconnect(); this.trackResize = null; this.track = null; this.rail = null;
    }
    get effectiveUrl() { return this.pendingUrl || new URL(location.href); }
    get grid() { return this.section.querySelector(this.gridSelector); }
    withPreview(current) {
      const url = new URL(current);
      if (/^\d+$/.test(this.dataset.previewThemeId || '')) url.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
      return url;
    }
    beforeForm(event) {
      const wrapper = event.target instanceof Element && event.target.closest('hdt-facet-filters-form');
      if (wrapper?.getAttribute('section-id') === this.sectionId) this.patchForms();
    }
    patchForms() {
      const current = this.effectiveUrl;
      document.querySelectorAll('hdt-facet-filters-form').forEach(wrapper => {
        if (wrapper.getAttribute('section-id') !== this.sectionId) return;
        const form = wrapper.querySelector('form');
        if (!form || !inCollection(form.action, this.base)) return;
        const action = new URL(this.base, location.origin);
        for (const key of [TYPE, 'preview_theme_id', 'view']) {
          const value = current.searchParams.get(key);
          if (value && !form.elements.namedItem(key)) action.searchParams.set(key, value);
        }
        form.action = action.toString();
      });
    }
    beforeFacet(event) {
      const detail = event.detail;
      if (!detail?.url) return;
      let url = this.withPreview(detail.url);
      if (url.origin !== location.origin || url.searchParams.get('section_id') !== this.sectionId || !inCollection(url, this.base)) return;
      if (this.syncingSort) { event.stopImmediatePropagation(); return; }
      if (!detail.notPushState && event.target?.closest?.('hdt-popover-sorting')) {
        // The native Sort builds from location.href, which can lag behind an in-flight selection.
        const selectedSort = url.searchParams.get('sort_by');
        url = this.withPreview(prepare(this.effectiveUrl));
        if (selectedSort) url.searchParams.set('sort_by', selectedSort);
        url.searchParams.set('section_id', this.sectionId);
      }
      if (!detail.masFishAction && !detail.notPushState && !url.searchParams.has(TYPE) && this.effectiveUrl.searchParams.has(TYPE)) url.searchParams.set(TYPE, this.effectiveUrl.searchParams.get(TYPE));
      event.stopImmediatePropagation(); event.preventDefault();
      this.loadGroup(prepare(url, false), { push: !detail.notPushState });
    }
    sync(url) {
      url = this.withPreview(url);
      const type = url.searchParams.get(TYPE) || '';
      this.section.toggleAttribute('data-fish-group-active', true);
      this.querySelectorAll('[data-fish-type]').forEach(link => {
        const active = link.dataset.fishType === type;
        link.classList.toggle('is-active', active); link.setAttribute('aria-pressed', String(active));
        if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        link.href = selectType(url, link.dataset.fishType).toString();
      });
      const stock = this.querySelector('[data-fish-stock]');
      if (stock) {
        const active = url.searchParams.getAll(STOCK).includes('1');
        stock.setAttribute('aria-pressed', String(active)); stock.classList.toggle('is-active', active);
        if (stock.tagName === 'A') stock.href = toggleStock(url).toString();
      }
      const price = this.querySelector('[data-fish-price]'), form = this.querySelector('[data-fish-price-form]');
      if (price) {
        price.classList.toggle('is-active', url.searchParams.has(MIN) || url.searchParams.has(MAX));
        price.setAttribute('aria-expanded', String(Boolean(form && !form.hidden)));
      }
      if (form) [MIN, MAX].forEach(key => { const input = form.elements.namedItem(key); if (input) input.value = url.searchParams.get(key) || ''; });
      const sort = this.querySelector('hdt-popover-sorting');
      const list = sort?.querySelector('hdt-richlist');
      if (list) {
        const selected = url.searchParams.get('sort_by') || this.dataset.defaultSort || 'manual';
        const choices = Array.from(list.querySelectorAll('[role="option"]'));
        const option = choices.find(item => item.value === selected);
        if (option) {
          this.syncingSort = true;
          try {
            list.setAttribute('selected', selected);
            choices.forEach(item => item.setAttribute('aria-selected', String(item === option)));
            const label = sort.querySelector('[change-text]');
            if (label) label.textContent = option.textContent.trim();
          } finally { this.syncingSort = false; }
        }
      }
      this.renderChips(url); this.patchForms();
      if (this.grid && this.paginationHost) this.grid.after(this.paginationHost);
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.revealActiveType();
        this.updateScrollButtons();
      });
    }
    sizeTrack() {
      const track = this.track; if (!track || !track.clientWidth) return;
      const style = getComputedStyle(track), items = track.querySelectorAll('[data-fish-type]');
      const gap = parseFloat(style.columnGap) || 0;
      const width = track.getBoundingClientRect().width - (parseFloat(style.borderLeftWidth) || 0) - (parseFloat(style.borderRightWidth) || 0) - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
      if (!items.length || width <= 0) return;
      const geometry = railGeometry(width, gap, parseFloat(style.getPropertyValue('--mas-fish-rail-min')) || 70, parseInt(style.getPropertyValue('--mas-fish-rail-max'), 10) || items.length, items.length);
      if (this.rail && Math.abs(this.rail.itemWidth - geometry.itemWidth) < .01 && this.rail.count === geometry.count) { this.updateScrollButtons(); return; }
      const start = this.rail ? Math.round(track.scrollLeft / this.rail.step) : 0;
      const wasEnd = this.rail && this.rail.lastStart > 0 && track.scrollLeft >= this.rail.lastStart * this.rail.step - 2;
      this.rail = geometry;
      track.style.setProperty('--mas-fish-rail-item-width', geometry.itemWidth + 'px');
      track.setAttribute('data-fish-rail-ready', '');
      track.scrollLeft = (wasEnd ? geometry.lastStart : Math.min(start, geometry.lastStart)) * geometry.step;
      this.updateScrollButtons();
    }
    revealActiveType() {
      const track = this.track; if (!track || !this.rail) return;
      const items = Array.from(track.querySelectorAll('[data-fish-type]'));
      const index = items.findIndex(item => item.classList.contains('is-active'));
      if (index < 0) return;
      const start = Math.round(track.scrollLeft / this.rail.step);
      track.scrollLeft = railVisibleStart(index, start, this.rail.count, items.length) * this.rail.step;
    }
    updateScrollButtons() {
      const track = this.track; if (!track) return;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.max(0, Math.min(maximum, track.scrollLeft));
      this.querySelectorAll('[data-fish-scroll]').forEach(button => {
        const disabled = maximum <= 2 || (Number(button.dataset.fishScroll) < 0 ? position <= 2 : maximum - position <= 2);
        button.disabled = disabled; button.setAttribute('aria-disabled', String(disabled));
      });
    }
    scrollTrack(direction) {
      if (!this.track || ![-1, 1].includes(direction)) return;
      this.sizeTrack();
      if (!this.rail) return;
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const start = Math.round(this.track.scrollLeft / this.rail.step);
      const next = Math.max(0, Math.min(this.rail.lastStart, start + direction * Math.max(1, Math.round(this.rail.count * .75))));
      this.track.scrollTo({ left: next * this.rail.step, behavior: reducedMotion ? 'auto' : 'smooth' });
      this.updateScrollButtons();
    }
    renderChips(url) {
      const host = this.querySelector('[data-fish-active]'); if (!host) return;
      host.replaceChildren();
      const chip = (label, target, attribute, value = '') => {
        const link = document.createElement('a'); link.className = 'mas-fish-filter__active-chip'; link.href = target.toString();
        link.setAttribute(attribute, value); link.setAttribute('aria-label', 'Remove ' + label + ' filter');
        const text = document.createElement('span'); text.textContent = label;
        const cross = document.createElement('span'); cross.setAttribute('aria-hidden', 'true'); cross.textContent = '×';
        link.append(text, cross); host.append(link);
      };
      const type = url.searchParams.get(TYPE), group = this.groups.get(type);
      if (type && group) chip(group.label, selectType(url, ''), 'data-fish-type');
      if (url.searchParams.has(STOCK)) chip(url.searchParams.getAll(STOCK).includes('1') ? 'In stock' : 'Out of stock', removeFilter(url, STOCK), 'data-fish-remove', STOCK);
      const min = url.searchParams.get(MIN), max = url.searchParams.get(MAX);
      if (min !== null || max !== null) chip(min !== null && max !== null ? 'A$' + min + ' – A$' + max : max !== null ? 'Up to A$' + max : 'From A$' + min, removeFilter(url, 'price'), 'data-fish-remove', 'price');
      if (host.children.length) {
        const clear = document.createElement('a'); clear.href = clearFilters(url).toString(); clear.setAttribute('data-fish-clear', ''); clear.className = 'mas-fish-filter__clear'; clear.textContent = 'Clear filters'; host.append(clear);
      }
      host.hidden = !host.children.length;
    }
    busy(active, message) {
      if (active) this.setAttribute('aria-busy', 'true'); else this.removeAttribute('aria-busy');
      this.section.toggleAttribute('data-fish-loading', active);
      if (this.grid) this.grid.setAttribute('aria-busy', String(active));
      if (message && this.status) this.status.textContent = message;
    }
    knownTotal(url, group) {
      if (group.subset || !inCollection(new URL(group.source, location.origin), this.base) ||
          Array.from(url.searchParams.keys()).some(key => key.startsWith('filter.'))) return null;
      const value = this.dataset.totalProducts;
      return value !== undefined && value !== '' && Number.isFinite(Number(value)) ? Math.max(0, Number(value)) : null;
    }
    async cardsFor(url, group, signal, needed) {
      const first = sourceUrl(url, group.source, this.dataset.previewThemeId), key = queryKey(first);
      let entry = cache.get(key);
      if (!entry || Date.now() - entry.time >= 60000) {
        entry = { time: Date.now(), streams: availabilityBuckets(url).map(bucket => {
          const start = new URL(first); start.searchParams.delete(STOCK); start.searchParams.set(STOCK, bucket);
          return { first: start, next: start, cards: [], visited: new Set(), complete: false, total: null };
        }) };
      }
      const known = this.knownTotal(url, group);
      const target = needed || (known === null ? Math.max(1, parseInt(url.searchParams.get('page'), 10) || 1) : pagination(known, this.size, url.searchParams.get('page')).page) * this.size;
      let cards = cardsInSubset(entry.streams.flatMap(stream => stream.cards), group.subset);
      while (cards.length < target && entry.streams.some(stream => !stream.complete)) {
        checkAbort(signal);
        const stream = entry.streams.find(item => !item.complete), address = stream.next.toString();
        if (stream.visited.has(address)) throw new Error('Repeated fish results page');
        const response = await fetch(address, { credentials: 'same-origin', signal, priority: needed ? 'low' : 'auto' });
        if (!response.ok) throw new Error('Fish results are unavailable');
        const text = await response.text(); checkAbort(signal);
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = parsed.querySelector('[data-fish-response]'), template = wrapper?.querySelector('template[data-fish-cards]');
        if (!wrapper || !template || !wrapper.hasAttribute('data-total-source') || wrapper.getAttribute('data-source') !== first.pathname.split('/').filter(Boolean).pop()) throw new Error('Incomplete fish response');
        const responseRecords = Array.from(template.content.children, cardRecord), nextValue = wrapper.getAttribute('data-next');
        const availableStream = stream.first.searchParams.get(STOCK) === '1';
        if (availableStream && responseRecords.some(record => !record.available)) throw new Error('Fish availability filter was not applied');
        // Shopify's unavailable filter also includes products with mixed stock variants.
        // They already belong to the available stream; retain only fully sold-out products here.
        const records = availableStream ? responseRecords : responseRecords.filter(record => !record.available);
        let next = null;
        if (nextValue) {
          next = new URL(nextValue, stream.next);
          if (next.origin !== first.origin || next.pathname !== first.pathname) throw new Error('Invalid fish results page');
          // Shopify pagination links may omit filters. Retain this stream's complete query.
          for (const retained of new Set(stream.first.searchParams.keys())) next.searchParams.delete(retained);
          for (const [name, value] of stream.first.searchParams) next.searchParams.append(name, value);
          if (next.toString() === address || stream.visited.has(next.toString())) throw new Error('Repeated fish results page');
        }
        checkAbort(signal);
        stream.cards.push(...records); stream.visited.add(address); stream.next = next; stream.complete = !next;
        const count = Number(wrapper.getAttribute('data-total-source'));
        stream.total = Number.isFinite(count) ? count : null;
        entry.time = Date.now(); cache.delete(key); cache.set(key, entry);
        while (cache.size > 12) cache.delete(cache.keys().next().value);
        cards = cardsInSubset(entry.streams.flatMap(item => item.cards), group.subset);
      }
      checkAbort(signal);
      const complete = entry.streams.every(stream => stream.complete);
      // Source counts are exact only for All Fish itself, never a pruned category source.
      const exactSingle = !group.subset && inCollection(new URL(group.source, location.origin), this.base) && entry.streams.length === 1 && entry.streams[0].first.searchParams.get(STOCK) === '1' ? entry.streams[0].total : null;
      return { cards, complete, total: complete ? cards.length : known !== null ? known : exactSingle };
    }
    cancelPrefetch() {
      clearTimeout(this.prefetchTimer); this.prefetchTimer = null;
      clearTimeout(this.prefetchTimeout); this.prefetchTimeout = null;
      this.prefetchRequest?.abort(); this.prefetchRequest = null;
    }
    prefetchNext(url, group, paging) {
      this.cancelPrefetch();
      if (!paging.hasNext) return;
      const connection = typeof navigator !== 'undefined' && navigator.connection;
      if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      this.prefetchTimer = setTimeout(async () => {
        this.prefetchTimer = null;
        if (!this.isConnected || document.hidden || this.pendingUrl || this.displayedQuery !== queryKey(url)) return;
        const job = new AbortController(); this.prefetchRequest = job;
        const timeout = setTimeout(() => job.abort(), 15000); this.prefetchTimeout = timeout;
        try {
          const result = await this.cardsFor(url, group, job.signal, (paging.page + 1) * this.size);
          if (result.complete && !job.signal.aborted && this.prefetchRequest === job && !this.pendingUrl && this.displayedUrl?.toString() === url.toString()) {
            const current = progressivePagination(result, this.size, paging.page);
            this.displayedCount = result.cards.length + (result.cards.length === 1 ? ' product' : ' products');
            this.displayedPaging = current;
            if (this.count) this.count.textContent = this.displayedCount;
            this.renderPagination(url, current);
          }
        }
        catch (_) { /* A speculative next page must never disrupt the displayed products. */ }
        finally { clearTimeout(timeout); if (this.prefetchRequest === job) { this.prefetchRequest = null; this.prefetchTimeout = null; } }
      }, 1500);
    }
    ensureGrid() {
      if (this.grid) return this.grid;
      const template = this.querySelector('template[data-fish-grid-template]');
      const grid = template?.content.firstElementChild?.cloneNode(true) || document.createElement('hdt-reval-items');
      if (!grid.id) grid.id = this.gridSelector.replace(/^#/, '');
      if (!grid.className) grid.className = this.dataset.gridClass || 'hdt-collection-products hdt-collection-has-pr6 hdt-row-grid hdt-grid-cols-2 md:hdt-grid-cols-3 lg:hdt-grid-cols-4 hdt-ratio--square';
      (this.section.querySelector('.hdt-shop-content') || this.parentElement).append(grid); return grid;
    }
    async loadGroup(input, { push = true, scroll = false, initial = false } = {}) {
      const url = this.withPreview(prepare(input, false)), group = this.groups.get(url.searchParams.get(TYPE) || '');
      this.request?.abort(); this.request = null; clearTimeout(this.groupTimer);
      this.cancelPrefetch();
      if (!group) { this.fail(url, 'This fish group is unavailable. Choose another group.'); return; }
      this.request = new AbortController(); const job = this.request;
      this.groupTimer = setTimeout(() => {
        if (this.isConnected && this.request === job) { job.abort(); this.fail(url); }
      }, 15000);
      this.status?.removeAttribute('data-fish-error');
      const quietInitial = initial && !url.searchParams.has(TYPE) && (parseInt(url.searchParams.get('page'), 10) || 1) === 1;
      this.pendingUrl = url; this.busy(!quietInitial, quietInitial ? 'Updating products…' : 'Loading ' + group.label + '…');
      this.section.querySelectorAll('[data-fish-empty], .hdt-template--filtered').forEach(panel => { panel.hidden = true; panel.style.display = 'none'; });
      if (this.paginationHost && !quietInitial) this.paginationHost.hidden = true;
      if (this.count && !quietInitial) this.count.textContent = 'Loading…';
      try {
        const result = await this.cardsFor(url, group, job.signal), cards = result.cards;
        if (job.signal.aborted || this.request !== job || !this.isConnected) return;
        clearTimeout(this.groupTimer);
        const paging = progressivePagination(result, this.size, url.searchParams.get('page'));
        const shownUrl = pageUrl(url, paging.page), grid = this.ensureGrid();
        const fragment = document.createElement('template'); fragment.innerHTML = cards.slice(paging.start, paging.end).join('');
        grid.replaceChildren(fragment.content.cloneNode(true)); grid.hidden = cards.length === 0;
        grid.style.display = cards.length ? '' : 'none';
        this.section.querySelectorAll('.hdt-template--filtered').forEach(empty => { empty.hidden = true; empty.style.display = 'none'; });
        if (push) history.pushState({ FacetUrl: shownUrl.toString(), section_id: this.sectionId }, '', shownUrl.toString());
        else if (shownUrl.toString() !== location.href) history.replaceState({ ...history.state, FacetUrl: shownUrl.toString(), section_id: this.sectionId }, '', shownUrl.toString());
        this.pendingUrl = null; this.sync(shownUrl);
        this.displayedQuery = queryKey(shownUrl);
        this.displayedCount = paging.total !== null ? paging.total + (paging.total === 1 ? ' product' : ' products') : 'Showing ' + (paging.start + 1) + '–' + paging.end;
        this.displayedPaging = paging; this.displayedUrl = shownUrl;
        if (this.count) this.count.textContent = this.displayedCount;
        this.renderPagination(shownUrl, paging); this.renderEmpty(cards.length === 0);
        this.busy(false, cards.length ? 'Showing products ' + (paging.start + 1) + '–' + paging.end + '.' : 'No fish match these filters.');
        grid.dispatchEvent(new CustomEvent('products:update', { bubbles: true }));
        // The theme's reveal animation assumes at least one product exists.
        if (cards.length && typeof grid.reveal === 'function') grid.reveal();
        if (scroll) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        this.prefetchNext(shownUrl, group, paging);
      } catch (error) {
        if (this.request === job) clearTimeout(this.groupTimer);
        if (this.request === job && error.name !== 'AbortError' && this.isConnected) this.fail(url);
      }
    }
    renderEmpty(empty) {
      let panel = this.section.querySelector('[data-fish-empty]');
      if (!panel) {
        panel = document.createElement('div'); panel.setAttribute('data-fish-empty', ''); panel.className = 'mas-fish-filter__empty';
        const title = document.createElement('p'); title.textContent = 'No fish match these filters.';
        const body = document.createElement('p'); body.textContent = 'Try another fish type or clear your filters.';
        const clear = document.createElement('a'); clear.textContent = 'Clear filters'; clear.setAttribute('data-fish-clear', ''); clear.className = 'mas-fish-filter__empty-clear';
        panel.append(title, body, clear); this.grid?.after(panel);
      }
      panel.hidden = !empty;
      panel.style.display = empty ? '' : 'none';
      const clear = panel.querySelector('[data-fish-clear]'); if (clear) clear.href = clearFilters(this.effectiveUrl).toString();
    }
    renderPagination(url, paging) {
      if (!this.paginationHost) return;
      this.paginationHost.replaceChildren(); this.paginationHost.hidden = paging.page === 1 && !paging.hasNext;
      if (this.paginationHost.hidden) return;
      this.paginationHost.setAttribute('aria-label', 'Fish result pages');
      const link = (label, page) => {
        const anchor = document.createElement('a'); anchor.href = pageUrl(url, page).toString(); anchor.dataset.fishPage = String(page); anchor.textContent = label; return anchor;
      };
      if (paging.page > 1) this.paginationHost.append(link('Previous', paging.page - 1));
      const status = document.createElement('span'); status.textContent = 'Page ' + paging.page + (paging.pages === null ? '' : ' of ' + paging.pages); this.paginationHost.append(status);
      if (paging.hasNext) this.paginationHost.append(link('Next', paging.page + 1));
    }
    fail(url, message = 'Could not load these fish. Please try again.') {
      this.busy(false); this.pendingUrl = null;
      const preserve = this.displayedQuery === queryKey(url) && this.grid?.children.length > 0;
      if (this.grid && !preserve) { this.grid.hidden = true; this.grid.style.display = 'none'; }
      if (preserve && this.displayedPaging) this.renderPagination(this.displayedUrl, this.displayedPaging);
      else if (this.paginationHost) this.paginationHost.hidden = true;
      this.section.querySelectorAll('[data-fish-empty], .hdt-template--filtered').forEach(panel => { panel.hidden = true; panel.style.display = 'none'; });
      if (this.count) this.count.textContent = preserve ? this.displayedCount : 'Unable to load';
      if (!this.status) return;
      this.status.replaceChildren(document.createTextNode(message + ' '));
      const retry = document.createElement('button'); retry.type = 'button'; retry.dataset.fishRetry = url.toString(); retry.textContent = 'Try again';
      this.status.append(retry); this.status.setAttribute('data-fish-error', '');
    }
    onClick(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const control = event.target.closest('[data-fish-type], [data-fish-stock], [data-fish-price], [data-fish-price-close], [data-fish-clear], [data-fish-remove], [data-fish-url], [data-fish-page], [data-fish-retry], [data-fish-scroll]');
      if (!control || !this.section.contains(control)) return;
      if (control.hasAttribute('data-fish-scroll')) {
        event.preventDefault(); if (!control.disabled) this.scrollTrack(Number(control.dataset.fishScroll)); return;
      }
      if (control.matches('[data-fish-price], [data-fish-price-close]')) {
        event.preventDefault(); const form = this.querySelector('[data-fish-price-form]');
        this.showPrice(!control.hasAttribute('data-fish-price-close') && Boolean(form?.hidden), control.hasAttribute('data-fish-price-close')); return;
      }
      let url;
      if (control.hasAttribute('data-fish-type')) url = selectType(this.effectiveUrl, control.dataset.fishType);
      else if (control.hasAttribute('data-fish-stock')) url = toggleStock(this.effectiveUrl);
      else if (control.hasAttribute('data-fish-remove')) url = removeFilter(this.effectiveUrl, control.dataset.fishRemove);
      else if (control.hasAttribute('data-fish-page')) url = pageUrl(this.effectiveUrl, Number(control.dataset.fishPage));
      else if (control.hasAttribute('data-fish-retry')) url = new URL(control.dataset.fishRetry);
      else if (control.hasAttribute('data-fish-url')) { url = prepare(control.href); if (this.effectiveUrl.searchParams.has(TYPE)) url.searchParams.set(TYPE, this.effectiveUrl.searchParams.get(TYPE)); }
      else url = clearFilters(this.effectiveUrl);
      event.preventDefault();
      const chooser = control.hasAttribute('data-fish-type') && control.closest('details.mas-fish-filter__more');
      if (chooser) {
        chooser.open = false;
        chooser.querySelector('summary')?.focus({ preventScroll: true });
      }
      this.render(url, { scroll: Boolean(chooser) || control.hasAttribute('data-fish-page') });
    }
    showPrice(open, returnFocus) {
      const form = this.querySelector('[data-fish-price-form]'), button = this.querySelector('[data-fish-price]');
      if (!form || !button) return;
      form.hidden = !open; button.setAttribute('aria-expanded', String(open));
      if (open) form.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
      else if (returnFocus) button.focus({ preventScroll: true });
    }
    onSubmit(event) {
      if (!event.target.matches('[data-fish-price-form]')) return;
      event.preventDefault(); const form = event.target, min = form.elements.namedItem(MIN), max = form.elements.namedItem(MAX);
      if (!min || !max) return;
      min.setCustomValidity(''); max.setCustomValidity(''); if (!form.reportValidity()) return;
      let url;
      try { url = setPrice(this.effectiveUrl, min.value, max.value); }
      catch (error) { max.setCustomValidity(error.message); max.reportValidity(); return; }
      this.showPrice(false, false); this.render(url);
    }
    render(url, options = {}) {
      this.status?.removeAttribute('data-fish-error');
      this.loadGroup(url, options);
    }
  }
  customElements.define('mas-fish-filter', FishFilter);
}());
